var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var PayrollAPI = /** @class */ (function (_super) {
    __extends(PayrollAPI, _super);
    function PayrollAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayrollAPI.prototype.setBankBalance = function (props) { return this.fetcher.post("/api/payroll/set-bank-balance", props); };
    PayrollAPI.prototype.listBankTransactions = function (props) { return this.fetcher.get("/api/payroll/bank-transactions", props); };
    PayrollAPI.prototype.listPeriods = function (props) { return this.fetcher.get("/api/payroll/periods", props); };
    PayrollAPI.prototype.listPeople = function (props) { return this.fetcher.get("/api/payroll/list-people-in-period", props); };
    PayrollAPI.prototype.getCurrent = function () { return this.fetcher.get("/api/payroll/current"); };
    PayrollAPI.prototype.approve = function () { return this.fetcher.post("/api/payroll/approve", {}); };
    PayrollAPI.prototype.downloadQuickbooks = function (period) { window.open("/api/payroll/quickbooks-download?period=" + period, "_blank"); };
    PayrollAPI.prototype.update = function (props) { return this.fetcher.post("/api/payroll/update-person", props); };
    PayrollAPI.prototype.listTimes = function (props) { return this.fetcher.get("/api/payroll/times-for-person-in-period", props); };
    return PayrollAPI;
}(SubAPI));
export { PayrollAPI };
